import React from "react";
import PropTypes from "prop-types";

const InputLabel = ({ htmlFor, className, text, required, onClick }) => {
  const requiredSpan = () => {
    return (
      <span className="inline-block w-[38px] h-[18px] text-[11px] ml-2.5 text-white text-center bg-[#fa5252] rounded-[20px]">
        必須
      </span>
    )
  };
  return (
    <label
      htmlFor={htmlFor}
      className={className}
      onClick={onClick}
    >
      {text}
      {required && requiredSpan()}
    </label>
  );
};

InputLabel.propTypes = {
  htmlFor: PropTypes.string,
  className: PropTypes.string,
  text: PropTypes.string,
  required: PropTypes.bool,
  onClick: PropTypes.func,
};

export default InputLabel;

